<template>
    <div id="hero">
        <section id="hero-section">
            <div class="container-fluid">
                <div class="row justify-content-center">
                    <div class="col-lg-10 col-sm-12">
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-7 order-md-1 order-2">
                        <div class="intro-message pt-md-5 mt-md-5">
                            <h1 class="h1-title">Build A Gorgeous App By Only Describing It</h1>
                            <p class="sub-explanation">SPIRITT is an AI platform that lets you build complex apps like Airbnb, Instagram, Doordash, and many more without any tech skills needed.</p>
                          <p class="description mt-5">We're hosting a workshop at <a class="link" target="_blank" href="https://schedule.sxswsydney.com/sessions/da125099-ac49-5e96-8dd3-53110609fa59">SXSW Sydney</a> (open to badge holders), offering attendees exclusive access to our platform, and bypassing our extensive waiting list.
In the workshop, <span class="gold">two of our founding team members</span> will help you optimize your app and share insights on how to start a startup.</p>
                            <p class="no-cv mt-5">**The workshop is closed for registration.</p>
                            <ul class="mt-2 d-flex p-0 list-unstyled col-12">
                                <!--<li class="d-md-block d-none">
                                    <router-link :to="{name: 'sxsw'}" class="btn btn-hero btn-hero-primary px-4">Sign Up for the Workshop</router-link>
                                </li>-->
                              <li class="d-md-block d-none">
                                <router-link :to="{name: 'home'}" class="mx-3 btn btn-hero btn-hero-secondary d-none d-lg-block">More About Us</router-link>
                              </li>
                              <!--<li class="d-md-none d-block col-6 px-1">
                                <router-link :to="{name: 'sxsw'}" class="btn btn-hero btn-hero-primary px-4 w-100 mw-100">Sign Up</router-link>
                              </li>-->
                              <li class="d-md-none d-block col-6 px-1">
                                <router-link :to="{name: 'home'}" class="btn btn-hero btn-hero-secondary d-lg-block w-100 mw-100">About Us</router-link>
                              </li>
                            </ul>
                        </div>
                    </div>
                            <div class="col-8 col-md-5 pl-md-4 mx-auto order-md-2 order-1">
                                <a href="https://schedule.sxswsydney.com/sessions/da125099-ac49-5e96-8dd3-53110609fa59" target="_blank"><img class="mx-auto img-fluid w-100 last-step" alt="last step"
                                     src="img/sxsw.png"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // import AnimatedCircles from '../AnimatedCircles.vue';

    export default {
        name: 'job-hero',
        components: {
            // 'animated-circles': AnimatedCircles,
        },
    }
</script>

<style lang="css" scoped>
    #hero-section {
        min-height: 100vh;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
        color: #fff;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        content: "";
        z-index: 1;
        -webkit-box-align: center;
        -ms-flex-align: center;
        position: relative;
       /* background-image: url("/img/why-choose-us/background.svg"), linear-gradient(309deg, #000000 51%, #771bae);*/
      background-image: linear-gradient(309deg, #000000 51%, #771bae);
        background-attachment: fixed;
      font-size: 20px;
        background-size: cover;
    }
    .h1-title {
        font-size: 4rem !important;
    }
    .sub-explanation {
      /*opacity: 0.6*/
    }
    .btn-hero {
        height: 48px;
        min-width: 240px;
        font-weight: bold;
        border-radius: 21px;
        cursor: pointer;
        font-size: 20px;
        border: none;
        padding-top: 10px;
    }
    .description {
      white-space: break-spaces;
    }

    .gold {
    background: radial-gradient(circle, #FFD235, #BF8D15);
      font-weight: bolder;
    background-size: cover;
      white-space: break-spaces;
    background-position: center;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;
    display: inline-block;
    border-radius: 0;
    }
    .last-step {
      user-drag: none;
      -webkit-user-drag: none;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
    }
    .btn-hero-primary, .btn-hero-primary:hover, .btn-hero-primary:focus, .btn-hero-primary:active {
        color: #ffffff;
        background-image: linear-gradient(101deg, #5b9bfb 2%, #00c092 96%) !important;
        padding-top: 10px;
        outline: none;
        border: none;
        transition: 0.3s;
    }
    .link {
      color: #5b9bfb;
    }
    .btn-hero-primary:hover {
        color: #751da7;
    }
    .no-cv{
      color: #14D1BD !important;;
    }
    .btn-hero-secondary {
        color: #751da7;
        background: #fff;
    }
    .btn-hero-secondary:hover {
        color: #751da7;
        background: #e0e0e0;
    }
    @media (max-width: 780px) {
      .h1-title {

        font-size: 2.1rem !important;
      }
      .btn-hero {

        min-width: unset;

      }
        #hero-section {
            min-height: calc(100vh);
          font-size: 16px !important;
        }

        .container-fluid{

        }
    }
</style>
